module.exports = __webpack_public_path__ + "img/massimo-vignelli.e10dbc5d.png";